import { CancelToken } from "axios";
import { useQuery } from "react-query";

import { makeSimpleGetRequest } from "lib/axios";
import { ATLAS_URL } from "services/constants";

import { AppConfigs } from "./types";

export const getAppConfigs = async (
  configs: string[],
  cancelToken?: CancelToken,
): Promise<AppConfigs> => {
  const params = new URLSearchParams();
  configs.forEach(c => params.append("configs", c));
  const queryString = params.toString();
  return await makeSimpleGetRequest(`${ATLAS_URL}/AppConfigs/?${queryString}`, {
    cancelToken,
  });
};

export const useAppConfigs = (configs: string[]) =>
  useQuery(["configs", configs], () => getAppConfigs(configs), {
    staleTime: Infinity,
  });
